var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.5312", cy: "18", r: "18", fill: "#A5C057" },
      }),
      _c("path", {
        attrs: {
          d: "M25.9946 29.1945H11.0686C10.8626 29.1945 10.6953 29.0275 10.6953 28.8216V7.17886C10.6953 6.97293 10.8626 6.80566 11.0686 6.80566H22.6361C22.735 6.80566 22.8301 6.84502 22.9001 6.91499L26.2584 10.2733C26.3284 10.3436 26.3678 10.4384 26.3678 10.5372V28.8216C26.3678 29.0275 26.2005 29.1945 25.9946 29.1945ZM11.4417 28.4483H25.6215V10.6916L22.4817 7.55192H11.4417V28.4483Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M25.9933 10.9103H22.6348C22.4288 10.9103 22.2617 10.7433 22.2617 10.5372V7.17884C22.2617 7.02811 22.3529 6.89187 22.492 6.83407C22.6311 6.77627 22.7919 6.80838 22.8988 6.91497L26.2571 10.2733C26.3637 10.38 26.3958 10.5405 26.338 10.68C26.2802 10.8197 26.1444 10.9103 25.9933 10.9103ZM23.0081 10.164H25.0925L23.0081 8.07951V10.164Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M25.9946 29.1938H11.0686C10.8626 29.1938 10.6953 29.0268 10.6953 28.8209V22.104C10.6953 21.8981 10.8626 21.731 11.0686 21.731H25.9946C26.2005 21.731 26.3678 21.8981 26.3678 22.104V28.8209C26.3678 29.0268 26.2005 29.1938 25.9946 29.1938ZM11.4417 28.4475H25.6215V22.4772H11.4417V28.4475Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.6779 20.2395C13.5773 20.2395 13.4766 20.1986 13.4029 20.1185C13.2634 19.9666 13.2739 19.7304 13.4255 19.5912L16.6771 16.606C16.8214 16.4739 17.0435 16.475 17.1858 16.6099L19.1584 18.4754C19.308 18.6169 19.3147 18.8534 19.173 19.003C19.0316 19.1531 18.7953 19.1599 18.6453 19.0181L16.9254 17.3911L13.9298 20.1412C13.8586 20.2069 13.7683 20.2395 13.6779 20.2395Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.1029 15.761C15.3827 15.761 14.7969 15.1752 14.7969 14.455C14.7969 13.7349 15.3827 13.1489 16.1029 13.1489C16.823 13.1489 17.409 13.7349 17.409 14.455C17.409 15.1752 16.823 15.761 16.1029 15.761ZM16.1029 13.8955C15.7943 13.8955 15.5431 14.1465 15.5431 14.455C15.5431 14.7636 15.7943 15.0148 16.1029 15.0148C16.4116 15.0148 16.6627 14.7636 16.6627 14.455C16.6627 14.1465 16.4116 13.8955 16.1029 13.8955Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M18.9086 19.1197C18.8157 19.1197 18.7228 19.0854 18.6507 19.0159L17.619 18.0282C17.4705 17.8861 17.4649 17.6502 17.607 17.5014L19.865 15.1307C19.9355 15.0569 20.0304 15.0185 20.1352 15.0146C20.2363 15.0146 20.3329 15.0556 20.4034 15.1281L23.6551 18.4864C23.7984 18.6346 23.7946 18.8708 23.6464 19.0142C23.4985 19.1578 23.2622 19.154 23.1188 19.006L20.1375 15.9267L18.4045 17.7462L19.1673 18.4767C19.316 18.6194 19.3213 18.8554 19.1789 19.0043C19.1048 19.0813 19.0067 19.1197 18.9086 19.1197Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.3797 20.6119H13.6777C13.4719 20.6119 13.3047 20.4446 13.3047 20.2388V12.0294C13.3047 11.8234 13.4719 11.6562 13.6777 11.6562H23.3797C23.5857 11.6562 23.7529 11.8234 23.7529 12.0294V20.2388C23.7529 20.4446 23.5857 20.6119 23.3797 20.6119ZM14.0511 19.8655H23.0067V12.4025H14.0511V19.8655Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M13.3107 27.7013C13.1048 27.7013 12.9375 27.5343 12.9375 27.3282V23.5967C12.9375 23.3908 13.1048 23.2236 13.3107 23.2236C13.5168 23.2236 13.6838 23.3908 13.6838 23.5967V27.3282C13.6838 27.5343 13.5168 27.7013 13.3107 27.7013Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M14.4303 26.2088H13.3107C13.1048 26.2088 12.9375 26.0415 12.9375 25.8357V23.5967C12.9375 23.3908 13.1048 23.2236 13.3107 23.2236H14.4303C15.2535 23.2236 15.9228 23.893 15.9228 24.7161C15.9228 25.5393 15.2535 26.2088 14.4303 26.2088ZM13.6838 25.4624H14.4303C14.8417 25.4624 15.1765 25.1279 15.1765 24.7161C15.1765 24.3045 14.8417 23.9699 14.4303 23.9699H13.6838V25.4624Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M19.6512 27.7013C19.5224 27.7013 19.3997 27.6345 19.3314 27.5204L17.7855 24.9443V27.3283C17.7855 27.5344 17.6183 27.7013 17.4124 27.7013C17.2063 27.7013 17.0391 27.5344 17.0391 27.3283V23.5967C17.0391 23.4288 17.1511 23.2819 17.3128 23.2371C17.4747 23.1927 17.6458 23.2608 17.7322 23.4045L19.278 25.9813V23.5967C19.278 23.3908 19.4452 23.2237 19.6512 23.2237C19.8572 23.2237 20.0245 23.3908 20.0245 23.5967V27.3283C20.0245 27.4962 19.9124 27.6431 19.7508 27.6881C19.7177 27.6972 19.6844 27.7013 19.6512 27.7013Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.0087 27.7013H22.267C21.6482 27.7013 21.1445 27.1979 21.1445 26.5786V24.3464C21.1445 23.7273 21.6482 23.2236 22.2673 23.2236H23.7566C23.9626 23.2236 24.1297 23.3908 24.1297 23.5967C24.1297 23.8026 23.9626 23.9699 23.7566 23.9699H22.2673C22.0596 23.9699 21.8908 24.1389 21.8908 24.3464V26.5786C21.8908 26.7864 22.0596 26.955 22.2673 26.955H23.0091C23.2155 26.955 23.3834 26.7871 23.3834 26.5808V25.4624C23.3834 25.2565 23.5506 25.0893 23.7566 25.0893C23.9626 25.0893 24.1297 25.2565 24.1297 25.4624V26.5808C24.1297 27.1988 23.6271 27.7013 23.0087 27.7013Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M23.7563 25.8362H23.0101C22.804 25.8362 22.6367 25.669 22.6367 25.4629C22.6367 25.257 22.804 25.0898 23.0101 25.0898H23.7563C23.9622 25.0898 24.1294 25.257 24.1294 25.4629C24.1294 25.669 23.9622 25.8362 23.7563 25.8362Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }